<template>
  <div>
    <div v-if="state.isEnded" class="d-flex align-items-baseline">
      <div class="badge badge-dark mr-2">
        {{ t("promotions.closed") }}
      </div>
      <div :class="textClass">
        <small>{{ t("promotions.groupBuy") }}</small> {{ t("promotions.ended") }}
      </div>
    </div>
  
    <div v-else class="d-flex align-items-baseline" :class="textClass">
      <small v-if="isComing" class="mr-2">{{ t("promotions.comingSoonSingle") }}</small>
      <small v-else class="mr-2">{{ t("promotions.countdownCloseSinglePromotion") }}</small>

      <div v-if="state.showDay" class="mr-2">
        {{ state.days }} 
        <small>
          {{ $t("global.day", state.days) }}<span v-if="!isComing">{{ $t("promotions.endDay") }}</span>
        </small>
      </div>

      <div v-if="state.showHour" class="mr-2">
        <small v-if="state.lessOneHour">
          {{ t("promotions.less") }} 
        </small>
        {{ state.hours }} 
        <small>
          {{ $t("global.hourFull", state.hours) }}<span v-if="!isComing">{{ $t("promotions.endDay") }}</span>
        </small>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, computed } from 'vue'
import { useI18n } from "vue-i18n"

const props = defineProps({
  startDate: String,
  endDate: String,
  textClass: {
    type: String,
    default: "text-primary",
  },
})
// const emit = defineEmits(['ended'])

const { t } = useI18n()

const isComing = computed(() => props.startDate ? dayjs(props.startDate) > dayjs() : false)
// const isEnded = computed(() => props.endDate ? dayjs(props.endDate) < dayjs() : false)

const state = reactive({
  days: null,
  hours: null,
  showDay: false,
  showHour: false,
  lessOneHour: false,
  isEnded: false,
  countdown: 0,
})

const setupCountdownTimer = () => {
  if (isComing.value) {
    state.countdown = dayjs(props.startDate).valueOf() - dayjs().valueOf();
  } else {
    state.countdown = dayjs(props.endDate).valueOf() - dayjs().valueOf();
  }

  if (state.countdown <= 0) {
    state.countdown = 0;
    state.isEnded = true;
    // emit("ended");
  }

  updateRemaining(state.countdown)

}

const updateRemaining = (distance) => {
  state.days = Math.floor(distance / (1000 * 60 * 60 * 24));
  state.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  
  if (state.days > 0) {
    state.showDay = true
    state.showHour = false
  } else {
    state.showDay = false
    state.showHour = true

    if (!state.hours) {
      state.hours = 1
      state.lessOneHour = true
    }
    
  }
}

onMounted(() => {
  setupCountdownTimer();
})

</script>
